import EcoImg from 'eco-design/base/eco-img';
import css from './index.module.scss';
import { useLang } from '@/i18n';

const I: React.FC = () => {
    const { t } = useLang('d3u');
    const imgs: [string, string] = [
        'https://websiteoss.ecoflow.com/upload/image/1768528231304/pc.jpg',
        'https://websiteoss.ecoflow.com/upload/image/1768528230759/mb.jpg',
    ];

    return (
        <section className={`${css.section} D3U-portable GtmModuleData-section`} id="D3U-portable" data-section-id={'D3U-portable'} data-section-id2={t('portable_title')}>
            <div className="info">
                <div className="label">{t('Portable_label')}</div>
                <div className="title">{t.rich('Portable_title', {
                    t: (t: string) => <span>{t}</span>
                })}</div>
                <div className="desc">{t('Portable_desc')}</div>
            </div>
            <div className="img">
                <EcoImg pc={imgs[0]} pad={imgs[0]} h5={imgs[1]} />
            </div>
        </section>
    );
};

export default I;
